var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolumeMute(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8C12 6.42667 11.0933 5.07556 9.77778 4.41778V6.38222L11.9556 8.56C11.9822 8.38222 12 8.19556 12 8ZM14.2222 8C14.2222 8.83556 14.0444 9.61778 13.7422 10.3467L15.0844 11.6889C15.6711 10.5867 16 9.33333 16 8C16 4.19556 13.3422 1.01333 9.77778 0.204444V2.03556C12.3467 2.8 14.2222 5.18222 14.2222 8ZM1.12889 0L0 1.12889L4.20444 5.33333H0V10.6667H3.55556L8 15.1111V9.12889L11.7778 12.9067C11.1822 13.3689 10.5156 13.7333 9.77778 13.9556V15.7867C11.0044 15.5111 12.1156 14.9422 13.0578 14.1778L14.8711 16L16 14.8711L8 6.87111L1.12889 0ZM8 0.888889L6.14222 2.74667L8 4.60444V0.888889Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeMute);
export default __webpack_public_path__ + "static/media/volume_mute.e72844c5.svg";
export { ForwardRef as ReactComponent };